export default __webpack_public_path__ + "static/angular-0ce6bd7291e0ab92269f88f88c7ec80e.svg";